import type { TxInternalsType } from 'types/api/internalTransaction';

export type Sort = 'value-asc' | 'value-desc' | 'gas-limit-asc' | 'gas-limit-desc' | 'default';
export type SortField = 'value' | 'gas-limit';

interface TxInternalsTypeItem {
  title: string;
  id: TxInternalsType;
}

export const TX_INTERNALS_ITEMS: Array<TxInternalsTypeItem> = [
  { title: '调用', id: 'call' },
  { title: '委托调用', id: 'delegatecall' },
  { title: '静态调用', id: 'staticcall' },
  { title: '创建', id: 'create' },
  { title: '创建2', id: 'create2' },
  { title: '自毁', id: 'selfdestruct' },
  { title: '奖励', id: 'reward' },
];
